module.exports = __webpack_public_path__ + "img/1 (10).e8286a6f.jpg";